export function convertNumber(string) {
  const input = string ? string : "0,00";
  return parseFloat(input.replace(",", "."));
}
